import React, { useContext, useEffect, useState } from 'react'
import styles from './styles.module.css'
import { FiltersContext } from 'client/components/FiltersContainer/context'
import Checkbox from 'src/comps/Checkbox'
import { Typography } from '@s4l/ds'
import { THEMES } from './constants'
import { useS4LContext } from '@s4l/react-context'

type Theme = (typeof THEMES)[number]['slug']

const FilterThemes = () => {
  const { filters, setFilters } = useContext(FiltersContext)
  const { i18n } = useS4LContext()
  const [selected, setSelected] = useState<Theme[]>([])

  function handleClick(theme: Theme) {
    const index = selected.indexOf(theme)
    const themeExists = index > -1
    const filteredThemes = themeExists
      ? selected.filter((f, i) => i !== index)
      : [...selected, theme]

    setFilters({ ...filters, themes: filteredThemes })
  }

  useEffect(() => {
    setSelected(filters.themes || [])
  }, [filters.themes])

  return (
    <div className={styles.container}>
      <Typography as="h3" size="l" bold className="mb-16">
        {i18n.formatMessage({ id: 'filter-category.trip-type' })}
      </Typography>
      <ul className={styles.list}>
        {THEMES.map(theme => {
          const isSelected = !!selected.find(f => f === theme.slug)

          return (
            <li key={theme.slug} className={styles.listItem}>
              <Checkbox
                label={<Typography size="l">{i18n.formatMessage({ id: theme.name })}</Typography>}
                name={`theme-${theme.slug}`}
                onChange={() => handleClick(theme.slug)}
                selected={isSelected}
              />
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default FilterThemes
